import React from "react";
import Family from './Family';

export default function General() {
  return (
    <>
      <Family />
    </>
  );
};